import {
  actionDic,
  optionsDic,
  ReportSupports,
} from '@/app/services/reportService/reportSupports'
import { cn } from '@/app/utils/cn'
import { formatName } from '@/app/utils/formatName'
import { Badge } from '@/view/components/ui/badge'
import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'

const columnHelper = createColumnHelper<ReportSupports>()

const columns = [
  columnHelper.accessor('createdAt', {
    id: 'createdAt',
    header: () => <div className="pl-2 text-left">Data</div>,
    cell: ({ row }) => (
      <div className="pl-4 text-left">
        {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
      </div>
    ),
  }),
  columnHelper.accessor('user.name', {
    id: 'name',
    header: () => (
      <div className="flex w-full flex-col items-start gap-1 pl-2">
        <div>Quem</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex w-full flex-col items-start gap-1 pl-4">
        <div>{formatName(row.original.user.name || '')}</div>
      </div>
    ),
  }),
  columnHelper.accessor('action', {
    id: 'action',
    header: () => <div className="text-center">Ação</div>,
    cell: ({ row }) => (
      <div className="">
        <div className="flex items-center justify-center gap-2">
          <Badge
            variant="outline"
            className={cn(
              'flex  items-center justify-center rounded-lg text-[10px]',
            )}
          >
            {actionDic[row.original.action] || '-'}
          </Badge>
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('props', {
    id: 'Categories',
    header: () => <div className="hidden text-start lg:block">Categoria</div>,
    cell: ({ row }) => (
      <div className="hidden lg:block">
        <div className="flex items-center justify-start gap-2">
          {row.original.props.options.map((option) => (
            <Badge
              key={option}
              variant="outline"
              className={cn(
                'flex items-center justify-center rounded-lg px-4 text-[10px]',
              )}
            >
              {optionsDic[option]}
            </Badge>
          ))}
        </div>
      </div>
    ),
  }),

  columnHelper.accessor('props', {
    id: 'props',
    header: () => (
      <div>
        <div className="text-lef">Conteúdo</div>
        <div className="hidden text-left text-black04 md:block lg:hidden">
          Categoria
        </div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col gap-2">
        <div className="text-left">{row.original.props.values.join(' | ')}</div>
        <div className="hidden md:block lg:hidden">
          <div className="flex items-center justify-start gap-2">
            {row.original.props.options.map((option) => (
              <Badge
                key={option}
                variant="outline"
                className={cn(
                  'flex items-center justify-center rounded-lg px-4 text-[10px]',
                  // `${category === SupportCategoryEnum.CUSTOMER && 'text-success'}`,
                  // `${category === SupportCategoryEnum.USER && 'text-info'}`,
                  // `${category === SupportCategoryEnum.TRANSACTION && 'text-error'}`,
                )}
              >
                {optionsDic[option]}
              </Badge>
            ))}
          </div>
        </div>
      </div>
    ),
  }),
]

export const TableReportSupportsColumnsDefinition = () => {
  return {
    columns,
  }
}
